import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { ApiUrls, Doctypes } from '../apiurls';
import { LOCAL_STORAGE_KEYS, LocalStorageItemsService } from '../../services/local-storage-items.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-hospitality-unit',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './hospitality-unit.component.html',
  styleUrl: './hospitality-unit.component.scss',
   encapsulation: ViewEncapsulation.None 
})
export class HospitalityUnitComponent {
  marsha_code_list: any = [];
  selectedMarshaDetails: any = {};
   isProductPage = false;
  constructor(
    private http: HttpClient,
    private router: Router,
    private localStorageService: LocalStorageItemsService
  ) {
    this.localStorageService.getItem$(LOCAL_STORAGE_KEYS.USERSCOMPANIES).subscribe((data) => {
      this.marsha_code_list = data || [];
    });
    // Set initial selected value to first item
    this.selectedValue = this.marsha_code_list[0]?.name || '';
    this.get_marsha_details();
  }

  // Manage label internally
  inputValue: string = '';

  // Output selected value if needed
  @Output() selectionChange = new EventEmitter<any>();

  selectedValue: string = '';
 ngOnInit() {
    this.checkRoute();
    // Optional: subscribe to route changes
    this.router.events.subscribe(() => {
      this.checkRoute();
    });
  }
  onSelectChange(event: any) {
    this.selectedValue = event.target.value;
    this.get_marsha_details();
  }
  checkRoute() {
   this.isProductPage =
  this.router.url.includes('/home/products') ||
  this.router.url.includes('/home/settings');

  }
  get_marsha_details() {
    const selectedCode = this.selectedValue || this.marsha_code_list[0]?.name;

    this.http.get(ApiUrls.get_by_name, {
      params: {
        doctype: Doctypes.marsha_code,
        name: selectedCode,
      }
    }).subscribe((res: any) => {
      if (res?.message?.success) {
        this.selectedMarshaDetails = res?.message?.message || {};

        // Emit the selected marsha code and details to parent component
        const selectionData = {
          marshaCode: selectedCode,
          marshaDetails: this.selectedMarshaDetails,
          selectedValue: this.selectedValue
        };

        this.selectionChange.emit(selectionData);
      }
    });
  }
}
